// libs
import React from 'react';
import { connect } from 'react-redux';

// selectors
import {
  getProductSizeOptions,
  getIsSizeGuideDataAvailable,
  isOneSize,
} from 'shared/store/details/selectors';
import { getRemoteConfig } from 'shared/store/remoteConfigs/selectors';

// helpers
import { canShowPDPMeasurements } from './helpers';

//components
import SizeOptionsV2 from './SizeOptionsV2';
import SizeOptions from './SizeOptions';

export interface ISizeOptionComponentProps {
  sizeOptions: ProductDetail.IProduct['sizeOptions'];
  isOneSize: boolean;
  canShowPDPMeasurements: boolean;
  isMobile: boolean;
}

const mapStateToProps = (state: any) => ({
  sizeOptions: getProductSizeOptions(state),
  isOneSize: isOneSize(state),
  canShowPDPMeasurements: canShowPDPMeasurements(getRemoteConfig(state, 'showPDPMeasurement')),
  isNewSizeChartEnabled: getRemoteConfig(state, 'newSizeChartEnabled'),
  sizeGuideDataAvailable: getIsSizeGuideDataAvailable(state),
});

const SizeOptionsComponent = ({ isMobile = false, ...props }: ISizeOptionComponentProps) => {
  return isMobile ? (
    <SizeOptionsV2 isMobile={true} {...props} />
  ) : (
    <SizeOptions isMobile={false} {...props} />
  );
};

export default connect(mapStateToProps)(SizeOptionsComponent);
